export default "__VITE_ASSET__d6db58df__"